import React, { useState, useEffect } from 'react';
import { useNotify } from 'react-admin';
import { useGetIdentity } from 'ra-core';
import { Box, Paper, Typography, Button as MUIButton, ListItemIcon, Dialog, DialogTitle, DialogContent, DialogActions, Divider, IconButton, Slide, CircularProgress, Button } from '@material-ui/core';
import { useTheme, makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CheckIcon from '@material-ui/icons/Check';
import './UserAreaScalesList.css';
import scalesProvider from '../../provider/scales.provider';
import { ScaleDetailDialog } from './ScaleDetailDialog';
import { getArea } from "../../services/master-tables.service";
import Spinner from '../../components/Spinner';
import { ScaleForm } from './ScaleForm';
import { ScaleList } from '../../resources/scales';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
    titleRoot: {
        paddingRight: theme.spacing(6),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
    },
}));

const UserAreaScalesList = (props) => {
    
    const notify = useNotify();
    const theme = useTheme();
    const classes = useStyles();
    // Treat tablet sizes as small layout as well
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const { identity } = useGetIdentity();
    const [expanded, setExpanded] = useState(true);
    const [scales, setScales] = useState([]);
    const [areas, setAreas] = useState([]);
    const [selectedAreaId, setSelectedAreaId] = useState(null);
    const [currentArea, setCurrentArea] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [scaleData, setScaleData] = useState(null);
    const [activeSpinner, setActiveSpinner] = useState(true);
    const [scaleForm, setScaleForm] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmScale, setConfirmScale] = useState(null);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [viewHistory, setViewHistory] = useState(false);
   
    // Perfiles profesionales
    // 'SOCIAL_WORKER', 'PSYCHOLOGIST', 'TASOC', 'THERAPIST'

    // // // // // // // 
    // ÁREAS
    // // // // // // // 
    //TS	Área de Trabajo Social
    //COMPL	Escalas Complementarias
    //ASC	Área de Animación Sociocultural
    //FISIO	Área de Fisioterapia
    //PSI	Área de Psicología
   
    const DEFAULT_AREA_BY_PROFESSIONAL = {
      SOCIAL_WORKER: 'TS',  
      PSYCHOLOGIST: 'PSI',
      THERAPIST: 'FISIO',
      TASOC: 'ASC'

    };

    const tableProps = {
        resource: "scales", // Cambias el resource aquí
        mode: "edit", // o el modo que necesites
        basePath: "/scales",
        hideTitle: true,
        clientId: props?.record?.id,
    };

    
    useEffect(() => {

        getArea().then(res => {
            const areaList = res?.elements || [];
            const sortedAreas = areaList.sort((a, b) => (a.order - b.order));
            setAreas(sortedAreas);
            //console.log(sortedAreas)
            // Si hay áreas, selecciona la primera al cargar
            if (sortedAreas.length > 0) {
                setSelectedAreaId(sortedAreas[0].id);
                setCurrentArea(sortedAreas[0]);
            }

            // Si hay áreas, selecciona la primera al cargar
            if (sortedAreas.length > 0) {
                
                const role = props?.professionalRole;
                
              const defaultAreaId =
                DEFAULT_AREA_BY_PROFESSIONAL[role] ||  null;

              const defaultArea =
                defaultAreaId
                  ? sortedAreas.find(a => a.code === defaultAreaId)
                  : null;

              const areaToSelect = defaultArea || sortedAreas[0];

              setSelectedAreaId(areaToSelect.id);
              setCurrentArea(areaToSelect);
            }
        });

        fetchScales();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (selectedAreaId && areas.length > 0) {
            const foundArea = areas.find(a => a.id === selectedAreaId);
            setCurrentArea(foundArea || areas[0]);
        }

        // eslint-disable-next-line
    }, [selectedAreaId, areas]);


    const fetchScales = async () => {
        const res = await scalesProvider.getScales(null, {
            pagination: { page: 1, perPage: 50 },
            sort: { field: 'Id', order: 'DESC' },
        });

        if (res) {
            setActiveSpinner(false);
            setScales(res?.data.sort((a, b) => a.order - b.order));
        }
    };


    const handleDetail = (scale) => {

        if (scale) {
            setScaleData(scale);
            setOpenDialog(true);
        }

    };

    const handleStartTest = async (scale) => {
        try {
            notify(`Iniciando test: ${scale.name}`, { type: 'info' });
            // Crear el registro de escala antes de abrir el formulario
            const payload = {
                data: {
                    scaleId: scale?.id,
                    clientId: props?.record?.id,
                    professionalId: identity?.professionalId,
                    evaluationDate: moment(new Date()).format('yyyy-MM-DDTHH:mm:ss'),
                }
            };

            const res = await scalesProvider.create(null, payload);
            if (res && res.data) {
                // Guardamos la escala y opcionalmente el registro creado
                setScaleData({ ...scale, register: res.data });
                setScaleForm(true);
            } else {
                notify('No se pudo iniciar el test (sin respuesta)', { type: 'warning' });
            }
        } catch (e) {
            console.error(e);
            notify('Error al iniciar el test', { type: 'error' });
        }
    };

    const openConfirmStart = (scale) => {
        setConfirmScale(scale);
        setConfirmOpen(true);
    };

    const confirmStart = async () => {
        if (!confirmScale) return;
        setConfirmLoading(true);
        await handleStartTest(confirmScale);
        setConfirmLoading(false);
        setConfirmOpen(false);
    };

    const handleViewHistory = () => {
        setViewHistory(true);
    };

    const handleCancelViewHistory = () => {
        setViewHistory(false);
    };

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleOpenMenu = (e) => setAnchorEl(e.currentTarget);
    const handleCloseMenu = () => setAnchorEl(null);
    const handleSelectArea = (id) => { setSelectedAreaId(id); handleCloseMenu(); };

    return (
        <>
            {
                activeSpinner && scales?.length === 0 && (
                    <Spinner />
                )
            }
            {
                !activeSpinner && scales?.length > 0 && !scaleForm && !viewHistory && (
                    <Paper className='ua-rootPaper' elevation={0}>
                        <Box display="flex" alignItems={isMobile ? 'flex-start' : 'center'} justifyContent={isMobile ? 'flex-start' : 'space-between'} mb={1} style={{ flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? 8 : 0, flexWrap: isMobile ? 'wrap' : 'nowrap' }}>
                            <h3 className='ua-headerTitle'>Escalas</h3>
                            <MUIButton
                                variant="outlined"
                                size="small"
                                color="primary"
                                onClick={handleOpenMenu}
                                endIcon={<ExpandMoreIcon />}
                                className='ua-areaButton'
                                style={isMobile ? { width: '100%' } : {}}
                            >
                                {currentArea?.value}
                            </MUIButton>
                            <Menu
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleCloseMenu}
                                getContentAnchorEl={null}
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                MenuListProps={{ dense: true }}
                            >
                                {areas.map(a => (
                                    <MenuItem key={a.id} selected={a.id === selectedAreaId} onClick={() => handleSelectArea(a.id)}>
                                        {a.id === selectedAreaId && (
                                            <ListItemIcon style={{ minWidth: 28 }}>
                                                <CheckIcon fontSize="small" />
                                            </ListItemIcon>
                                        )}
                                        <Typography variant="body2" style={{ fontWeight: a.id === selectedAreaId ? 600 : 400 }}>
                                            {a.value}
                                        </Typography>
                                    </MenuItem>
                                ))}
                            </Menu>
                        </Box>

                        <div className='div-expand' onClick={() => setExpanded(!expanded)}>
                            <span className={expanded ? 'span-expand' : 'span-not-expand'}>{expanded ? '▼' : '►'}</span>
                            <Typography variant="subtitle2"  >
                                {currentArea?.value}
                            </Typography>
                        </div>

                        {expanded && scales?.length > 0 && (
                            <Box>
                                {scales?.filter(f => f.areaId === selectedAreaId).map((scale) => (
                                    <Paper key={scale.id} className='ua-card' variant="outlined">
                                        <Box display="flex" justifyContent="space-between" alignItems={isMobile ? 'flex-start' : 'center'} style={{ flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? 8 : 0, flexWrap: isMobile ? 'wrap' : 'nowrap' }}>
                                            <Box>
                                                <Typography variant="subtitle1" className='ua-cardTitle'>{scale?.name}</Typography>
                                                <Typography variant="body2" style={{ color: '#5f6b7a' }}>Tiempo estimado: {scale?.estimatedTime || '—'} min</Typography>
                                                <Typography variant="body2" style={{ color: '#5f6b7a' }}>Items: {scale?.items}</Typography>
                                            </Box>
                                            <Box display="flex" className='ua-actions' style={{ gap: 10, width: isMobile ? '100%' : 'auto', flexDirection: isMobile ? 'column' : 'row' }}>
                                                <MUIButton
                                                    variant={isMobile ? 'contained' : 'outlined'}
                                                    color="primary"
                                                    className='ua-actionBtn'
                                                    onClick={() => handleDetail(scale)}
                                                    fullWidth={isMobile}
                                                >
                                                    Detalle
                                                </MUIButton>

                                                <MUIButton
                                                    variant={isMobile ? 'contained' : 'outlined'}
                                                    color="primary"
                                                    className='ua-actionBtn'
                                                    onClick={() => openConfirmStart(scale)}
                                                    fullWidth={isMobile}
                                                >
                                                    Iniciar Test
                                                </MUIButton>
                                            </Box>
                                        </Box>
                                    </Paper>
                                ))}

                                <Box display="flex" justifyContent="flex-end" mt={1}>
                                    <Typography variant="body2" color="primary" className='ua-history' onClick={handleViewHistory}>
                                        Ver histórico
                                    </Typography>
                                </Box>
                            </Box>
                        )}

                        <ScaleDetailDialog
                            {...props}
                            open={openDialog}
                            data={scaleData}
                            onClose={() => {
                                setOpenDialog(false);
                            }}
                            onSaved={() => {
                                setOpenDialog(false);
                            }}
                        />
                        <Dialog
                            open={confirmOpen}
                            onClose={() => (!confirmLoading && setConfirmOpen(false))}
                            aria-labelledby="confirm-start-dialog-title"
                            fullWidth
                            maxWidth="xs"
                            disableBackdropClick={confirmLoading}
                            disableEscapeKeyDown={confirmLoading}
                            TransitionComponent={Slide}
                            TransitionProps={{ direction: 'up' }}
                        >
                            <DialogTitle id="confirm-start-dialog-title" disableTypography className={classes.titleRoot}>
                                <Typography variant="h6">Iniciar test</Typography>
                                <IconButton
                                    aria-label="Cerrar"
                                    onClick={() => (!confirmLoading && setConfirmOpen(false))}
                                    className={classes.closeButton}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </DialogTitle>
                            <Divider />
                            <DialogContent>
                                <Typography variant="body2">
                                    ¿Deseas iniciar el test "{confirmScale?.name}"?
                                </Typography>
                            </DialogContent>
                            <DialogActions>
                                <MUIButton onClick={() => setConfirmOpen(false)} disabled={confirmLoading}>Cancelar</MUIButton>
                                <MUIButton
                                    color="primary"
                                    variant="contained"
                                    onClick={confirmStart}
                                    disabled={confirmLoading}
                                    autoFocus
                                >
                                    Confirmar
                                    {confirmLoading && (
                                        <CircularProgress size={18} color="inherit" style={{ marginLeft: 8 }} />
                                    )}
                                </MUIButton>
                            </DialogActions>
                        </Dialog>
                    </Paper>
                )
            }
            {/* Formulario dinamico */}
            {
                scaleForm && !viewHistory && (
                    <ScaleForm
                        {...props}
                        isNew={true}
                        scaleForm={scaleForm}
                        onCancel={() => setScaleForm(false)}
                        data={scaleData}
                    />
                )
            }
            {/*  Historico */}
            {
                !scaleForm && viewHistory && (
                    <>
                        <h3 className='ua-headerTitle'>Histórico de Escala</h3>

                        <ScaleList
                            {...tableProps}

                        />
                        <div style={{ textAlign: 'right', padding: '2% 0'}}>

                            <Button
                                    color="primary"
                                    variant="outlined"
                                    onClick={() => handleCancelViewHistory()}
                                >
                                    Volver
                                </Button>
                        </div>
                    </> 

                )
            }


        </>



    );
}

export default UserAreaScalesList;
